$(document).on("turbolinks:load", function(){
  if ($('#banner_content').length) {
    M.textareaAutoResize($('#banner_content'))
  }
  $("#modal-jumbotron-link").click(function(event){
    event.preventDefault()
    $("#modal-jumbotron").modal('open')
  })
})